import {useUserInformation} from "thermia-react-container";

export const useIsAdmin = () => {
  const info = useUserInformation();
  return info.permissions.includes("rc_adm");
}